"use client"
import Link from "next/link"
import DedicatedCardProfile from "./dedicated-card-profile"

const DedicatedCard: React.FC = () => {
  return (
    <div className="hire-team dedicated-dev card text-start hire-section">
      <div className="h-full bg-transparent">
        <div className="grid dedicated-box text-start">
          <DedicatedCardProfile />
          <p className="fs-lg text-primary mb-1 fw-700">Looking to Hire</p>
          <p className="text-primary fs-lgxl fw-700">Dedicated Developers?</p>
          <ul className="list text-body dedicated-points fs-md mb-4">
            <li>Experienced &amp; Skilled Resources</li>
            <li>Flexible Pricing &amp; Working Models</li>
            <li>Communication via Skype/Email/Phone</li>
            <li>NDA and Contract Signup</li>
            <li>On-time Delivery &amp; Post Launch Support</li>
          </ul>
            <Link href="/contact-us" className="btn btn-primary w-full">
              Let&apos;s Talk
            </Link>
        </div>
      </div>
    </div>
  )
}

export default DedicatedCard
